// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","primary":"Button_primary__9MLUH","secondary":"Button_secondary__sUGsj","tertiary":"Button_tertiary__ioTKC","danger":"Button_danger__U+J2L"};